import type { OrderContractPriceBasis } from '@hero/schema';
import { computePriceBasisLegacy, type PriceBasisInput } from './computePriceBasis';

export type PriceFinality = OrderContractPriceBasis;

/**
 * Whether the leg's **current** load price honors a pre-agreed route
 * quote (`route_quoted`) or is manual / off-quote (`manual`).
 *
 * Prefers persisted `leg.priceBasis` when set; falls back to legacy
 * derivation for pre-migration rows.
 */
export function getPriceFinality(leg: PriceBasisInput | null | undefined): PriceFinality {
  if (leg == null) return 'manual';

  if (leg.priceBasis === 'route_quoted' || leg.priceBasis === 'manual') {
    return leg.priceBasis;
  }

  return computePriceBasisLegacy(leg);
}
